import * as Yup from 'yup';
import { LegalProceedingAnnexes } from '../../../../../../shared/types/legalProceedings/legalProceedings';

export const initialValues: LegalProceedingAnnexes = {
    observations: '',
};

export const validationSchema = Yup.object({});
